 <div class="report-model" >

                
                <app-datatable-title [title]="'reports.projects'" [count]="projectsCount" [countTitle]="'reports.totalProjects'"></app-datatable-title>

                    <app-housevilla-inventory-projects [showLoader]="!loading"
                    [tableColumns]="projectsColumns"
                    [dataLength]="projectsCount"
                    [tableData]="projectsdata"
                    (pageEvent)="onPageEvent($event)"
                    (sort)="sortData($event)"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'project', 'c')" [downloadLoading]="downloadLoading['c']"
                    [showEstaterText]="true">
                </app-housevilla-inventory-projects>
                   

            </div>